import { Col } from 'react-bootstrap';
import CompareIcon from '../../../CompareIcon';
import { format } from 'date-fns';
import { BrregEnhetResponse } from 'services/KjederegisteretAdminApi/BrregApi/types';
import { OrgNrInfo } from './types';
import { CompareStatus } from '../../../../utils';
import Style from '../../index.module.css';

interface Props {
  compareStatus: CompareStatus;
  brregFirst?: BrregEnhetResponse;
  incomingOrgNr?: string;
  onTransferFromIncoming: (value: OrgNrInfo) => void;
}

const OrgNrCompareCell = ({
  compareStatus,
  brregFirst,
  incomingOrgNr,
  onTransferFromIncoming,
}: Props) => {
  const handleTransfer = () => {
    if (incomingOrgNr && brregFirst?.name) {
      onTransferFromIncoming({
        juridisknavn: brregFirst.name,
        organisasjonsnr: incomingOrgNr,
        isOrgnrValidated: true,
      });
    }
  };

  const renderIcon = () => {
    if (brregFirst?.finnesIkke) {
      return (
        <CompareIcon
          compareStatus={'ugyldig'}
          tooltipText="Finner ikke organisasjonsnummer i Brreg"
        />
      );
    }
    if (brregFirst?.slettedato) {
      const raw = brregFirst.slettedato as unknown as string | number | Date;
      const date = raw instanceof Date ? raw : new Date(raw);
      return (
        <CompareIcon
          compareStatus={'ugyldig'}
          tooltipText={`Organisasjonsnummer er markert som slettet ${isNaN(date.getTime()) ? '' : format(date, 'dd.MM.yyyy')} i Brreg.`}
        />
      );
    }
    return <CompareIcon compareStatus={compareStatus} onClick={handleTransfer} />;
  };

  return (
    <Col xs="auto" md={2} className={Style.compareIconContainer}>
      {renderIcon()}
    </Col>
  );
};

export default OrgNrCompareCell;
